import type { RefObject } from 'react'
import { createPortal } from 'react-dom'

import type { OptionWithRenderedValue } from './useResolvedRenderedValues'

export const HiddenUnresolvedDomValues = <T,>({
  optionsRequiringTextExtraction,
  textExtractionRefs,
}: {
  optionsRequiringTextExtraction: OptionWithRenderedValue<T>[]
  textExtractionRefs: RefObject<Record<string, HTMLSpanElement | null>>
}) =>
  createPortal(
    <div className="hidden" aria-hidden>
      {optionsRequiringTextExtraction.map(({ key, renderedInputValue }) => (
        <span
          key={key}
          ref={(element) => {
            textExtractionRefs.current[key] = element
          }}
        >
          {renderedInputValue}
        </span>
      ))}
    </div>,
    document.body,
  )
